module.exports = __webpack_public_path__ + "img/slider-under-3.27caeb45.png";